// extracted by mini-css-extract-plugin
module.exports = {"tile":"Tile_tile__JrXQw","imgWrapper":"Tile_imgWrapper__9KR2M","pill":"Tile_pill__RWcST","description":"Tile_description__o6HUJ"};